function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Field } from 'react-final-form';
import pluralize from 'pluralize';
import fspUtils from '@unite-us/client-utils/dist/utils/feeSchedulePrograms';
import CapsInfo from '../../components/service_authorization/CapsInfo';
import { DurationField } from '@unite-us/ui';
import { InputField } from '@unite-us/app-components';
import SearchableField from '../../components/SearchableField';
import CurrencyField from '../../common/form/CurrencyField';
import DollarAmount from '../../components/DollarAmount';
import useClinicalModificationOptions from '../../hooks/useClinicalModificationOptions';
import LineItem from './LineItem';
var AuthFormLineItem = function AuthFormLineItem(props) {
  return /*#__PURE__*/React.createElement(LineItem, _extends({
    fieldClassName: "col-span-1 p-0 text-dark-grey",
    valueClassName: "col-span-2 m-0 p-0 text-dark-blue"
  }, props));
};
var AuthorizationSubform = function AuthorizationSubform(_ref) {
  var _formValues$paymentAu, _formValues$paymentAu2, _formValues$amount_re;
  var feeScheduleProgram = _ref.feeScheduleProgram,
    formValues = _ref.formValues,
    setReferralErrors = _ref.setReferralErrors;
  var isCostBased = fspUtils.isCostPaymentType(feeScheduleProgram.payment_type);
  var showUnits = !isCostBased && (feeScheduleProgram === null || feeScheduleProgram === void 0 ? void 0 : feeScheduleProgram.unit);
  var showRate = showUnits && (feeScheduleProgram === null || feeScheduleProgram === void 0 ? void 0 : feeScheduleProgram.unit_rate) > 0;
  var hasDatesSelected = !!(formValues !== null && formValues !== void 0 && (_formValues$paymentAu = formValues.paymentAuthForm) !== null && _formValues$paymentAu !== void 0 && _formValues$paymentAu.service_start && formValues !== null && formValues !== void 0 && (_formValues$paymentAu2 = formValues.paymentAuthForm) !== null && _formValues$paymentAu2 !== void 0 && _formValues$paymentAu2.service_end);
  var _useState = useState(undefined),
    _useState2 = _slicedToArray(_useState, 2),
    icdSearchQuery = _useState2[0],
    setIcdSearchQuery = _useState2[1];
  var icdOptions = useClinicalModificationOptions(icdSearchQuery);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "space-y-6"
  }, /*#__PURE__*/React.createElement("h5", {
    className: "text-sm ui-form-field__label m-0"
  }, "AUTHORIZATION REQUEST"), /*#__PURE__*/React.createElement("dl", {
    className: "grid grid-cols-3 gap-x-6 gap-y-2"
  }, /*#__PURE__*/React.createElement(AuthFormLineItem, {
    field: "Contracted Program"
  }, feeScheduleProgram.name), /*#__PURE__*/React.createElement(AuthFormLineItem, {
    field: "Payment Approach"
  }, fspUtils.PAYMENT_TYPES[feeScheduleProgram.payment_type] || 'N/A'), showUnits && /*#__PURE__*/React.createElement(AuthFormLineItem, {
    field: "Unit"
  }, feeScheduleProgram.unit), showRate && /*#__PURE__*/React.createElement(AuthFormLineItem, {
    field: "Rate"
  }, /*#__PURE__*/React.createElement(DollarAmount, {
    value: feeScheduleProgram.unit_rate,
    convertCents: true
  }), ' per ', feeScheduleProgram.unit), /*#__PURE__*/React.createElement(AuthFormLineItem, {
    field: "Program Cap"
  }, feeScheduleProgram.cap_information ? /*#__PURE__*/React.createElement("div", {
    dangerouslySetInnerHTML: {
      __html: feeScheduleProgram.cap_information
    }
  }) : 'No cap')), /*#__PURE__*/React.createElement("hr", {
    className: "p-0"
  }), /*#__PURE__*/React.createElement("div", {
    className: "grid grid-cols-3 gap-x-6 gap-y-3"
  }, /*#__PURE__*/React.createElement(Field, {
    name: "paymentAuthForm.amount_requested"
  }, function (params) {
    return isCostBased ? /*#__PURE__*/React.createElement(CurrencyField, _extends({
      className: "col-span-1 px-0",
      id: "authorization-request-amount-requested",
      label: "Amount Requested",
      required: true
    }, params)) : /*#__PURE__*/React.createElement(InputField, _extends({
      className: "col-span-1 px-0",
      id: "authorization-request-amount-requested",
      label: "Amount Requested",
      type: "number",
      required: true
    }, params));
  }), /*#__PURE__*/React.createElement("div", {
    className: "col-span-2 p-0 space-y-2"
  }, /*#__PURE__*/React.createElement("div", {
    className: "font-heavy-font text-dark-grey"
  }, "Unit"), /*#__PURE__*/React.createElement("div", {
    className: "capitalize"
  }, isCostBased ? 'Dollars' : pluralize(feeScheduleProgram.unit || '', (formValues === null || formValues === void 0 || (_formValues$amount_re = formValues.amount_requested) === null || _formValues$amount_re === void 0 ? void 0 : _formValues$amount_re.value) || 0))), /*#__PURE__*/React.createElement("div", {
    className: "col-span-1 p-0 m-0"
  }, /*#__PURE__*/React.createElement(Field, {
    name: "paymentAuthForm.service_start"
  }, function (startProps) {
    return /*#__PURE__*/React.createElement(Field, {
      name: "paymentAuthForm.service_end"
    }, function (endProps) {
      return /*#__PURE__*/React.createElement(DurationField, {
        id: "authorization-request-service-dates",
        label: "Service Delivery Date(s)",
        startField: startProps,
        startFieldPath: "startField",
        endField: endProps,
        endFieldPath: "endField",
        required: true,
        style: {
          container: {
            width: 'unset'
          }
        }
      });
    });
  })), feeScheduleProgram.cm_code_required_on_authorization && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "col-span-1 p-0 m-0 mb-8 row-start-4",
    "data-testid": "icd10-dropdown"
  }, /*#__PURE__*/React.createElement(Field, {
    name: "paymentAuthForm.icd10_code"
  }, function (params) {
    var onSelectionChange = function onSelectionChange(newVal) {
      params.input.onChange(newVal);
      setIcdSearchQuery(newVal.label);
    };
    var onInputChange = function onInputChange(value) {
      setIcdSearchQuery(value);
      params.input.onChange('');
    };
    return /*#__PURE__*/React.createElement(SearchableField, _extends({
      className: "",
      id: "authorization-request-icd10-code",
      label: "ICD-10 Code",
      labelClassName: "tracking-normal",
      onChange: onSelectionChange,
      options: icdOptions,
      onInputChange: onInputChange,
      placeholder: "Select an ICD-10 code",
      clearable: true,
      required: true
    }, params));
  }))))), hasDatesSelected && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("hr", {
    className: "mb-6"
  }), /*#__PURE__*/React.createElement(CapsInfo, {
    feeScheduleProgram: feeScheduleProgram,
    formValues: formValues,
    isCostBased: isCostBased,
    setReferralErrors: setReferralErrors
  })));
};
AuthorizationSubform.propTypes = {
  feeScheduleProgram: PropTypes.object.isRequired,
  formValues: PropTypes.object.isRequired,
  setReferralErrors: PropTypes.func.isRequired
};
export default AuthorizationSubform;
//# sourceMappingURL=AuthorizationSubform.js.map